/* @generated */

// src/assets/ui-icon/line/bug.tsx
import * as React from "react";
var BugLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M16.5 13.5h2V12h-2V9H15v-.25a3.324 3.324 0 0 0-.769-2.284l.69-1.38-1.342-.671-.629 1.256a4.316 4.316 0 0 0-2.4 0l-.629-1.256-1.342.67.69 1.38A3.325 3.325 0 0 0 8.5 8.75V9H7v3H5v1.5h2v1.25c0 .1.007.191.011.287l-1.943.486.364 1.455 1.822-.456C7.84 18.413 9.428 19.5 11.75 19.5c2.303 0 3.883-1.068 4.481-2.93l1.856.412.326-1.464-1.926-.428c.006-.113.013-.224.013-.34V13.5ZM10 8.75C10 7.54 10.54 7 11.75 7s1.75.54 1.75 1.75V9H10v-.25Zm5 6c0 2.126-1.124 3.25-3.25 3.25S8.5 16.876 8.5 14.75V10.5H15v4.25Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  BugLine
};
